import { apiGet, apiPost, apiPut, apiDelete } from "../client";
import type {
	ApprovalWorkflowListResponseApi,
	ApprovalWorkflowResponseApi,
	ApprovalWorkflowStageResponseApi,
	CreateApprovalWorkflowRequestApi,
	UpdateApprovalWorkflowRequestApi,
	CreateApprovalWorkflowStageRequestApi,
	UpdateApprovalWorkflowStageRequestApi,
} from "../models/approvalWorkflow";

export async function getApprovalWorkflows(): Promise<ApprovalWorkflowListResponseApi> {
	return apiGet<ApprovalWorkflowListResponseApi>("approval-workflows");
}

export async function getApprovalWorkflowById(
	workflowId: number,
): Promise<ApprovalWorkflowResponseApi> {
	return apiGet<ApprovalWorkflowResponseApi>(
		`approval-workflows/${workflowId}`,
	);
}

export async function createApprovalWorkflow(
	request: CreateApprovalWorkflowRequestApi,
): Promise<ApprovalWorkflowResponseApi> {
	return apiPost<ApprovalWorkflowResponseApi>("approval-workflows", request);
}

export async function updateApprovalWorkflow(
	workflowId: number,
	request: UpdateApprovalWorkflowRequestApi,
): Promise<ApprovalWorkflowResponseApi> {
	return apiPut<ApprovalWorkflowResponseApi>(
		`approval-workflows/${workflowId}`,
		request,
	);
}

export async function deleteApprovalWorkflow(
	workflowId: number,
): Promise<void> {
	return apiDelete<void>(`approval-workflows/${workflowId}`);
}

export async function createApprovalWorkflowStage(
	workflowId: number,
	request: CreateApprovalWorkflowStageRequestApi,
): Promise<ApprovalWorkflowStageResponseApi> {
	return apiPost<ApprovalWorkflowStageResponseApi>(
		`approval-workflows/${workflowId}/stages`,
		request,
	);
}

export async function updateApprovalWorkflowStage(
	workflowId: number,
	stageId: number,
	request: UpdateApprovalWorkflowStageRequestApi,
): Promise<ApprovalWorkflowStageResponseApi> {
	return apiPut<ApprovalWorkflowStageResponseApi>(
		`approval-workflows/${workflowId}/stages/${stageId}`,
		request,
	);
}

export async function deleteApprovalWorkflowStage(
	workflowId: number,
	stageId: number,
): Promise<void> {
	return apiDelete<void>(
		`approval-workflows/${workflowId}/stages/${stageId}`,
	);
}
